module.exports = __webpack_public_path__ + "img/vi.8a74e2f6.svg";